export enum Basemap {
  OpenStreetMaps = 'OpenStreetMaps',
  GoogleMaps = 'GoogleMaps',
  GoogleMapsPositron = 'GoogleMapsPositron',
  GoogleMapsSatellite = 'GoogleMapsSatellite',
  GoogleMapsHybrid = 'GoogleMapsHybrid',
}

export interface BasemapOption {
  id: Basemap
  name: string
}

export interface ViewState {
  center: [number, number]
  zoom: number
  provider: string
}
